import { useEffect } from 'react';
import { toProps } from '@graphistry/falcor';
import { container } from '@graphistry/falcor-react-redux';
import getContext from 'react-recompose/getContext';
import { Selection as SelectionComponent } from '@graphistry/viz/src/components/selection';
import { getSelectionLabelFragment, PATH_STRING_SELECTION_LABELS } from '@graphistry/viz/src/client/falcor/LocalDataSink';
import PropTypes from 'prop-types';

let Selection = ({ mask = {}, ...props }) => {
    const { edge, point, labels, onPublishedPathUpdated } = props;
    useEffect(() => {
        onPublishedPathUpdated({
            path: PATH_STRING_SELECTION_LABELS,
            data: { edge, point, labels }
        });
    }, [onPublishedPathUpdated, edge, point, labels]);

    return <SelectionComponent mask={toProps(mask)} {...props} />;
};

Selection = getContext({ onPublishedPathUpdated: PropTypes.func })(Selection);

Selection = container({
    renderLoading: false,
    fragment: ({ edge = [], point = [], labels = {}} = {}) => (
        `{
            ${getSelectionLabelFragment(point.length, edge.length)}
            mask, type, edge, cursor, point, darken
        }`)
})(Selection);

export { Selection };
